<template>
  <BaseListContactsPage
    :tabs="tabs"
    :current-tab="currentTab"
    :contacts-selectable="!massTextIcon.disabled"
    :get-gql-query="getGqlQuery"
    :get-items="getItems"
    :get-total-items-count="getTotalItemsCount"
    :get-query-variables="getQueryVariables"
    :update-context-variable="updateContextVariable"
    :on-tab-changed="onTabChanged"
    :get-total-contacts="getTotalContacts"
  />
</template>

<script>
import BaseListContactsPage from '@/pages/BaseListContactsPage'
import { LIST_POLLING_CHOICE_CONTACTS } from '@/backend/graphql/pollingGQL'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PollingChoiceContactsPage',
  components: { BaseListContactsPage },
  data: function () {
    return {
      currentTab: 'tab-1',
      getGqlQuery: LIST_POLLING_CHOICE_CONTACTS,
      limit: 50,
      offset: 0,
      orderBy: '-profile__last_recv_at,name',
      pollingEventChoiceId: 0,
      window: {
        width: 0,
        height: 0
      },
      tabs: {
        'tab-1': this.$route.query.pollingEventChoiceName
      }
    }
  },
  computed: {
    ...mapGetters({ massTextIcon: 'toolBar/getMassTextIcon' })
  },
  created () {
    this.pollingEventChoiceId = this.$route.params.pollingEventChoiceId
    this.setEditMenuItems({ val: [
      { title: 'Edit Contacts',
        route: { name: 'editPollingChoiceContacts',
          params: { pollingEventChoiceId: this.pollingEventChoiceId } } },
      { title: 'Add Contacts' },
      { title: 'Remove Contacts' }
    ] })
  },
  methods: {
    ...mapActions({ setEditMenuItems: 'toolBar/setEditMenuItems' }),
    getItems (data) {
      return data.listChoiceProfile.results.map(obj => obj.profile)
    },
    getTotalItemsCount (data) {
      return data.listChoiceProfile.totalCount
    },
    getQueryVariables () {
      return {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        pollingEventChoiceId: this.pollingEventChoiceId
      }
    },
    updateContextVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    },
    getTotalContacts (value) {
      if (value === this.currentTab) { return this.$store.getters['contact/getTotalCount'] } else { return '?' }
    },
    onTabChanged (value) {
      this.currentTab = value
    }
  }
}
</script>

<style scoped>

</style>
